<template lang="pug">
    ib-dialog(
        :width="width",
        :height="height",
        role="alertdialog",
        :describedby="id",
        inline)
        ._dlg-alert.article(:id="id", dir="auto", v-markdown._blank="msg")
        template(v-slot:footer)
            ._mdismiss(v-if="dismissable")
                ib-checkbox(v-model="dismiss", class="fs7") {{$locale.data.dismissable}}
            ib-button-group
                ib-button(v-if="type == 'confirm'", @click="onCancel") {{verbCancel || $locale.data.Cancel}}
                ib-button(@click="onAccept", :tone="tone || 'accent'", autofocus) {{verb || $locale.data.Accept}}
</template>

<script>
    /**
     * A modal that displays a Markdown formatted message, with affirmative or declinatory dismiss buttons.
     */
    export default {
        name: 'alert',

        props: {
            /**
             * The message displayed in the dialog.
             */
            msg: String,
            /**
             * `alert` or `confirm`.
             */
            type: String,
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String,
            /**
             * Semantic tone; used to display icon. Supported tones are `important`, `warning`, and `error`.
             */
            tone: String,
            /**
             * An alternative label for the action button.
             * This should almost always be specified. Users will not read the message in your dialog box.
             */
            verb: String,
            /**
             * An alternative label for the dismiss button.
             */
            verbCancel: String,
            /**
             * A function called after clicking the Accept button.
             */
            action: Function,
            /**
             * A function called after clicking the Cancel button.
             */
            cancel: Function,
            /**
             * If `true`, display a "Do not show this message again" checkbox and pass its value
             * as an option to the `action` function.
             */
            dismissable: Boolean
        },

        data() {
            return {
                dismiss: false
            };
        },

        computed: {
            id() {
                return '_al' + this._uid;
            }
        },

        methods: {
            onCancel() {
                this.$emit('close');
                this.cancel && this.cancel();
            },

            onAccept() {
                this.$emit('close');
                this.action && this.action({ dismiss: this.dismiss });
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._dlg-alert {
        flex: 1 1 auto;
        .alert-msg();
        table {
            width: 100%;
        }
    }
</style>
